import { RetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const isBrandInRetailerView = () => {
  const { retailerToken } = RetailerStore.get();
  return !!retailerToken && retailerToken.startsWith("r_b_");
};
